import EverflowSDK from "@everflow/everflow-sdk";

export const EVERFLOW_TRACKING_DOMAIN = "https://www.ehtnh2d4.com";

let configured = false;

/**
 * Everflow JS SDK (@everflow/everflow-sdk) — listecle script tag yerine npm paketi.
 * window.EF üzerinden TemplatePreview / CreateLink ile uyumlu.
 */
export function initEverflowSdk() {
  if (configured) return EverflowSDK;

  EverflowSDK.configure({
    tracking_domain: EVERFLOW_TRACKING_DOMAIN,
  });

  if (typeof window !== "undefined") {
    window.EF = EverflowSDK;
  }

  configured = true;
  return EverflowSDK;
}

export function getEverflowSdk() {
  return initEverflowSdk();
}
